import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/ar";
import { useDispatch, useSelector } from "react-redux";
import {
  setCountLoading,
  toggleBookmarkPost,
  togglePostReaction,
} from "../../redux/features/postsSlice";
import { useState, useRef, useEffect } from "react";
import toast from "react-hot-toast";
import DOMPurify from "dompurify";

const PostItem = ({ post, isLoggedIn, loggedInUserId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const postLoading = useSelector(
    (state) => state.posts.count_loading[post?.first_post_details?.post_id]
  );
  const postOptionsRef = useRef(null);
  const dotsRef = useRef(null);
  const [likeCount, setLikeCount] = useState(post?.like_count);
  const [isLiked, setIsLiked] = useState(
    post?.first_post_details?.is_post_liked
  );
  const [isPostMenuOpen, setIsPostMenuOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        postOptionsRef.current &&
        !postOptionsRef.current.contains(event.target) &&
        dotsRef.current &&
        !dotsRef.current.contains(event.target)
      ) {
        setIsPostMenuOpen(false); // Close the dropdown if you click outside it or not on the dots
      }
    };

    if (isPostMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside); // Add listener to window when dropdown is open
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Clean up listener if it's closed
    };
  }, [isPostMenuOpen]);

  const handleOpenPostMenu = () => {
    setIsPostMenuOpen(!isPostMenuOpen);
  };

  function extractTextAndTruncate(description) {
    //sanitize the html
    const cleanHTML = DOMPurify.sanitize(description, {
      FORBID_TAGS: ["script", "iframe"], // Disallow specific tags
      FORBID_ATTR: ["onclick", "onload", "onerror"], // Disallow specific attributes
    });

    // Remove all image tags
    const textWithoutImages = cleanHTML.replace(/<img[^>]*>/g, "");

    // Replace all heading tags with <p> tags
    const textWithPTags = textWithoutImages
      .replace(/<h[1-6][^>]*>/g, "<p>")
      .replace(/<\/h[1-6]>/g, "</p>")
      .replace(/<\/?strong>/g, "");

    // Truncate the text to 100 characters
    const truncatedText = textWithPTags.slice(0, 100);

    return truncatedText;
  }
  const handleBookmarkPost = async () => {
    if (!isLoggedIn) {
      // navigate("/login");
      window.location.href =
        process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
      return false;
    }
    // dispatch(setIndiLoading({ actionType: "bookmark", postId: post.id, value: true }));

    await dispatch(toggleBookmarkPost(post));

    // dispatch(setIndiLoading({ actionType: "bookmark", postId: post.id, value: false }));
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href + "detail/" + post.id);
    toast.success("تم نسخ الرابط إلى الحافظة", { position: "top-center" });
  };
  async function handleLikePost() {
    if (!isLoggedIn) {
      window.location.href =
        process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
      return;
    }

    let postId = post?.first_post_details?.post_id;
    if (postLoading) return; // Prevent duplicate requests while loading
    dispatch(setCountLoading({ postId, loading: true }));

    const nextIsLiked = !isLiked;
    const nextLikeCount = nextIsLiked ? likeCount + 1 : likeCount - 1;

    // **Optimistic UI Update**
    setIsLiked(nextIsLiked);
    setLikeCount(nextLikeCount);

    // **Call API**
    try {
      await dispatch(togglePostReaction(postId, nextIsLiked));
    } catch (err) {
      console.error("Error toggling reaction:", err);

      // **Revert UI on failure**
      setIsLiked(!nextIsLiked);
      setLikeCount(nextIsLiked ? likeCount - 1 : likeCount + 1);
    } finally {
      dispatch(setCountLoading({ postId, loading: false }));
    }
  }
  const humanFriendlyDate = moment(post.last_posted_at || post.created_at)
    .locale("ar")
    .fromNow();
  const poster_image = `${
    process.env.REACT_APP_API_URL +
    post.topic_creator?.avatar.replace("{size}", "100")
  }`;
  return (
    // sm:max-w-[1085px]
    <div
      className="px-4 flex flex-col w-full py-5 bg-white border rounded-2xl mb-2"
      style={{ boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.06)" }}
    >
      <div>
        <div
          className="flex items-start cursor-pointer"
          onClick={() => {
            navigate(`/detail/${post.id}`, {
              state: {
                topicTag: post?.tags?.[0],
              },
            });
          }}
        >
          <div className="flex justify-between w-full">
            <div className="flex justify-between w-full">
              <div className="flex gap-3" alt="">
                <img
                  src={poster_image}
                  alt=""
                  className="cursor-pointer w-[30px] h-[30px] sm:w-[44px] sm:h-[44px] rounded-full"
                  onClick={(event) => {
                    event.stopPropagation();
                    navigate("/profile", {
                      state: {
                        username: post.topic_creator?.username,
                        id: post.topic_creator?.id,
                      },
                    });
                  }}
                />

                <div className="flex-col cursor-pointer flex-grow">
                  <div className="flex gap-2 text-[14px] flex-wrap">
                    <div className="flex items-center gap-3 ">
                      <p className="mb-1 text-[#444444] text-medium">
                        {post?.topic_creator?.name?.length === 0
                          ? post?.topic_creator?.username
                          : post?.topic_creator?.name}
                      </p>
                      <div className=" flex  gap-1">
                        <img
                          src={post.category?.emoji}
                          alt="emoji"
                          className="inline-block max-w-5 max-h-5"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/images/logo.svg";
                          }}
                        />
                        <span className="mb-1 text-[#666] text-nowrap">
                          {post.category?.name}
                        </span>
                      </div>
                    </div>
                    <div className="flex">
                      {post.has_accepted_answer && (
                        <div className="bg-[#EFFBF6] rounded-full mb-1 w-auto">
                          <div className="flex gap-2 ps-1 pe-2">
                            <img src="/images/home/tick.svg" alt="" />
                            <span className="text-[#008C56] mt-[3px]">
                              تم الاجابة
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* <div className="flex sm:hidden">
                                        {post.has_accepted_answer && (
                                            <div className="bg-[#EFFBF6] rounded-full w-[7rem] sm:w-auto">
                                                <div className="flex gap-2 px-2">
                                                    <img src="/images/home/tick.svg" alt="" />
                                                    <span className="text-[#008C56]  mt-[3px]">تم الاجابة</span>
                                                </div>
                                            </div>
                                        )}
                                    </div> */}
                  <p className="mt-3 font-bold cursor-pointer break-words">
                    {post?.title || post?.topic_creator?.title}{" "}
                  </p>
                  <div
                    className="content text-right mb-4 mt-1 ellipsis break-words text-[#666] text-[14px]"
                    dangerouslySetInnerHTML={{
                      __html: extractTextAndTruncate(post.cooked || ""),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`flex gap-5 justify-between mx-1.5 mt-2.5 ${
          isPostMenuOpen ? "max-sm:relative" : "static"
        }`}
      >
        <div className="flex gap-3 sm:gap-[22px]">
          {/* like */}
          <button
            className="flex gap-1 sm:gap-2 items-center justify-center "
            disabled={postLoading}
          >
            {postLoading ? (
              <div className=" flex justify-center items-center w-[101px]">
                <img
                  loading="eager"
                  src="/images/salla_loader_big.svg"
                  alt="Loading..."
                  className="w-[12px] h-[15px] loader"
                />
              </div>
            ) : (
              <>
                <img
                  src={`/images/home/${
                    isLoggedIn && post?.first_post_details?.is_post_liked
                      ? "like-filled"
                      : "like"
                  }.svg`}
                  title={
                    isLoggedIn
                      ? post?.topic_creator?.id !== loggedInUserId
                        ? ""
                        : "لا يمكنك الإعجاب بمنشورك الخاص"
                      : "تسجيل الدخول لمثل"
                  }
                  onClick={() => {
                    if (!isLoggedIn) {
                      window.location.href =
                        process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
                    } else if (post?.topic_creator?.id !== loggedInUserId) {
                      handleLikePost();
                    }
                  }}
                  alt="Heart"
                  className={`${
                    post?.topic_creator?.id !== loggedInUserId
                      ? "cursor-pointer"
                      : "cursor-not-allowed"
                  }`}
                />
                <span className="mt-1 text-[#999999] text-[14px]">
                  الإعجابات ({likeCount})
                </span>
              </>
            )}
          </button>
          {/* reply */}
          <div
            className={"flex gap-1 sm:gap-2 items-center justify-center"}
            onClick={() => {
              if (!isLoggedIn) {
                window.location.href =
                  process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
              } else {
                navigate(
                  `/detail/${post.id}/${
                    post.highest_post_number ?? post.post_number
                  }`,
                  {
                    state: {
                      reply_mode: true,
                    },
                  }
                );
              }
            }}
          >
            <img
              src="/images/home/comment.svg"
              title={isLoggedIn ? "" : "تسجيل الدخول للرد"}
              alt=""
              className={`sm:w-auto cursor-pointer`}
            />
            <span className="mt-1 text-[#999999] text-[14px]">
              التعليقات ({post.posts_count - 1})
            </span>
          </div>
          {/* post views */}
          {/* <div className="flex gap-1 sm:gap-2 items-center justify-center">
                        <img src="/images/home/eye.svg" alt="" className=" sm:w-auto" />
                        <span className="mt-1 text-[#999999]">{post.views}</span>
                    </div> */}
        </div>

        <div
          ref={postOptionsRef}
          className="sm:!flex sm:flex-row flex-col hidden gap-2 sm:gap-4 sm:items-center items-start max-sm:absolute top-6 end-0 max-sm:bg-white max-sm:px-3 max-sm:py-2 rounded-md max-sm:border max-sm:shadow-md"
          style={{ display: isPostMenuOpen ? "flex" : "none" }}
        >
          {/* date */}
          <div className="flex gap-2 justify-center items-center">
            <img
              src="/images/home/clock.svg"
              alt="clock"
              className="sm:hidden"
            />
            <span className="mt-1 text-[#999999] text-nowrap text-[15px]">
              {humanFriendlyDate.replace("منذ", "قبل")}
            </span>
          </div>
          <hr className="-mx-3 self-stretch sm:hidden" />
          {/* bookmark */}
          <div
            className="flex gap-1 sm:gap-2 items-center justify-center"
            onClick={() => {
              if (!isLoggedIn) {
                window.location.href =
                  process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
              } else {
                handleBookmarkPost();
                handleOpenPostMenu();
              }
            }}
          >
            <div className="cursor-pointer flex items-center gap-2">
              {post?.first_post_details?.is_post_bookmarked && isLoggedIn ? (
                <img
                  src="/images/post/save-filled.svg"
                  alt="saved"
                  className="w-4"
                />
              ) : (
                <img
                  src="/images/home/save.svg"
                  alt="save"
                  title={!isLoggedIn ? "تسجيل الدخول إلى المرجعية" : ""}
                />
              )}
              <span className="text-[#999] text-sm sm:hidden">اقرأ لاحقًا</span>
            </div>
          </div>
          <hr className="-mx-3 self-stretch sm:hidden" />
          {/* copy to clipboard */}
          <div
            className="cursor-pointer flex items-center gap-2"
            onClick={() => {
              handleCopyToClipboard();
              handleOpenPostMenu();
            }}
          >
            <img src="/images/home/copy-to-clipboard.svg" alt="copy" />
            <span className="text-[#999] text-sm sm:hidden">نسخ الرابط</span>
          </div>
        </div>
        <div
          ref={dotsRef}
          className="sm:!hidden flex ps-2"
          onClick={() => {
            handleOpenPostMenu();
          }}
        >
          <img src="/images/more.svg" alt="..." />
        </div>
      </div>
    </div>
  );
};
export default PostItem;
